import { createRecipe } from './runtime';

const formLabelConfig = {"name":"formLabel","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl"]}}

export const formLabel = /* @__PURE__ */ createRecipe(formLabelConfig)